import { AxiosRequestConfig } from 'axios';
import { Buffer } from 'buffer';
// import { useFileSystem } from '../hooks/useFileSystem';
import { Platform } from 'react-native';
import BackgroundService from 'react-native-background-actions';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
// import paths, { getStreamURI } from '../../../nk-store/src/api/paths';
// import axios, { AxiosRequestConfig } from 'axios';
// import PushNotification from 'react-native-push-notification';
import {
  displayLocalPush,
  FeedUploadStatusEnum,
  getStreamURI,
  getVideoDetails,
  ICreateResumableMedia,
  IResumableMedia,
  LanguageJson,
  languageMap,
  MMKVStoreKeyMap,
  mmkvUserProfilePersistence,
  moderationPostQuestionAndFeedAsync,
  StreamClient,
  toolId,
  useAppPersistenceStore,
  useFileSystem,
  useProfileStore
} from '@ninjacart/nc-nk-store';

const peertubeBase = getStreamURI();
const TRANSCODING_INTERVAL = 30000;
let isTransCoding = false;
interface IProgresBarConfig {
  progressPercentage: number;
  isError: boolean;
  isSuccess: boolean;
  inProgress: boolean;
}
interface transCodingQueue {
  [key: string]: IResumableMedia;
}
export interface IResumableQnaStore {
  resumableQna: Array<IResumableMedia>;
  addResumableQna: (qna: IResumableMedia) => void;
  updateResumableQna: (qna: IResumableMedia) => void;
  removeResumableQna: (index: number) => void;
  uploadResumableInit: (
    payload: IResumableMedia,
    headers: Record<string, any>
  ) => Promise<string | null | undefined>;
  uploadResumable: (payload: string, data: any, headers: Record<string, any>) => void;
  executeChunkUpload: (payload: IResumableMedia) => Promise<boolean>;
  isAnyTaskRunning: () => boolean;
  publishVideoToPeerTube: (config: {
    videoId: string;
    resumableQna: IResumableMedia;
    shortUUID: string;
  }) => void;
  uploadVideoToMastodon: (config: {
    payload: {};
    header: {};
    resumableQna: IResumableMedia;
  }) => void;
  progresBarConfig: IProgresBarConfig;
  setProgresBarConfig: (config: IProgresBarConfig) => void;
  isVideoUploding: boolean;
  setVideoUploding: (flage: boolean) => void;
  transCodingQueue: transCodingQueue;
  setTransCodingQueue: (key: string, value: IResumableMedia) => void;
  removeTransCodingItem: (key: string) => void;
  triggerTransCoding: (videoId: string) => void;
  currentResumableQna: IResumableMedia;
  setCurrentResumableQna: (value: IResumableMedia) => void;
  resetResumableQnaStore: () => void;
  // removeItem: (item: IResumableFeed) => void;
}

const initialState = {
  resumableQna: [],
  currentResumableQna: {},
  progresBarConfig: {
    progressPercentage: 0,
    isError: false,
    isSuccess: false,
    inProgress: false,
  },
  transCodingQueue: {},
};

export const useResumableQnaStore = create<IResumableQnaStore>()(
  devtools(
    persist<IResumableQnaStore>(
      (set, get) => ({
        resumableQna: [],
        currentResumableQna: {},
        progresBarConfig: {
          progressPercentage: 0,
          isError: false,
          isSuccess: false,
          inProgress: false,
        },
        transCodingQueue: {},
        setTransCodingQueue: (key: string, value: IResumableMedia) =>
          set((state) => ({
            ...state,
            transCodingQueue: {
              ...state.transCodingQueue,
              [key]: value,
            },
          })),
        removeTransCodingItem: (key: string) => {
          set((state) => {
            const newTransCodingQueue = { ...state.transCodingQueue };
            delete newTransCodingQueue[key];
            return { ...state, transCodingQueue: newTransCodingQueue };
          });
        },
        setProgresBarConfig: (config: IProgresBarConfig) => set({ progresBarConfig: config }),
        addResumableQna: (qna: IResumableMedia) => {
          qna.feedIndex = get()?.resumableQna.length;
          set((state) => ({ resumableQna: [...state.resumableQna, qna] }));
        },
        setCurrentResumableQna: (resumableQna: IResumableMedia) =>
          set({ currentResumableQna: resumableQna }),
        removeResumableQna: (index: number) =>
          set((state) => ({
            resumableQna: get()?.resumableQna.splice(index, 1),
          })),
        updateResumableQna: (payload: IResumableMedia) => {
          const qna = get()?.resumableQna;
          qna[payload.feedIndex!] = payload;
          set(() => ({ resumableQna: qna }));
        },
        uploadResumableInit: async (payload: IResumableMedia, headers) => {
          // useResumableFeedStore.getState().setVideoUploding(false);
          const progresBarConfig = get().progresBarConfig;
          useResumableQnaStore.getState().setProgresBarConfig({
            isError: false,
            isSuccess: false,
            progressPercentage: 0,
            inProgress: true,
          });
          try {
            const createMedia: ICreateResumableMedia = {
              channelId: payload.channelId ?? '1',
              filename: payload.fileName,
              name: payload.name,
            };
            const res = await StreamClient.post(
              `${peertubeBase}/api/v1/videos/upload-resumable`,
              createMedia,
              { headers: headers }
            );

            if (res.status === 201) {
              const remoteLocation = res.headers['location'];
              payload.remoteLocation = remoteLocation;

              return payload.remoteLocation;
            }
          } catch (err) {
            useResumableQnaStore.getState().setProgresBarConfig({
              ...progresBarConfig,
              isError: true,
              isSuccess: false,
              inProgress: false,
            });
          }

          return null;
        },
        uploadResumable: async (remoteLocation: string, data: any, headers) => {
          const progresBarConfig = get().progresBarConfig;
          try {
            const res = await StreamClient.put(`${remoteLocation}`, data, { headers: headers });
          } catch (err) {
            useResumableQnaStore.getState().setProgresBarConfig({
              ...progresBarConfig,
              isError: true,
              isSuccess: false,
              inProgress: false,
            });
          }
        },
        executeChunkUpload: async (resumableQna: IResumableMedia) => {
          const progresBarConfig = get().progresBarConfig;

          const peerTubeToken = useProfileStore.getState()?.streamConfig?.access_token;
          try {
            if (BackgroundService.isRunning()) {
              console.log('Background task is running. Please wait until it completes...');
              return false;
            }

            const initUpload = get()?.uploadResumableInit;
            const token = `Bearer ${peerTubeToken}`;
            const initHeaders = {
              authorization: token,
              'x-upload-content-length': resumableQna?.mediaFile?.fileSize,
              'x-upload-content-type': resumableQna.mediaFile?.mimeType,
            };

            if (initUpload) {
              const remoteLocation = await initUpload(resumableQna, initHeaders);
              if (remoteLocation) {
                resumableQna.remoteLocation = remoteLocation;
                resumableQna.status = FeedUploadStatusEnum.INPROGRESS;
                get()?.updateResumableQna(resumableQna);
                const taskDefinition = getBackgroundServiceTaskInfo(resumableQna);
                await BackgroundService.start(
                  () => uploadFileInChunks(resumableQna, get()?.updateResumableQna),
                  taskDefinition
                );
              }
            }
          } catch (err) {
            useResumableQnaStore.getState().setProgresBarConfig({
              ...progresBarConfig,
              isError: true,
              isSuccess: false,
              inProgress: false,
            });
          }

          return true;
        },
        isAnyTaskRunning: () => {
          // BackgroundService.stop();
          return BackgroundService.isRunning();
        },
        triggerTransCoding: async (videoId: string) => {
          if (isTransCoding) {
            return;
          }
          isTransCoding = true;
          const transCodingQueue = useResumableQnaStore.getState()?.transCodingQueue;
          //check if item is alredy present in queue
          if (transCodingQueue[`video_id_${videoId}`]) {
            let resumableQna = transCodingQueue[`video_id_${videoId}`];
            //check if item is alredy isPublished then delete item from queue
            if (transCodingQueue[`video_id_${videoId}`].isPublished) {
              useResumableQnaStore.getState().removeTransCodingItem(`video_id_${videoId}`);
            }

            //check if item is alredy TransCoded then delete item from queue and publish the video
            else if (transCodingQueue[`video_id_${videoId}`].isTransCoded) {
              useResumableQnaStore.getState().publishVideoToPeerTube({
                videoId: videoId,
                resumableQna: transCodingQueue[`video_id_${videoId}`],
                shortUUID: resumableQna?.shortUUID,
              });
            } else {
              try {
                const getMediaMetadata = await getVideoDetails(videoId);
                if (getMediaMetadata?.status === 200) {
                  if (
                    getMediaMetadata?.data?.files.length > 0 &&
                    getMediaMetadata?.data?.streamingPlaylists?.length === 0
                  ) {
                    await new Promise((resolve) => setTimeout(resolve, TRANSCODING_INTERVAL));
                    isTransCoding = false;
                    useResumableQnaStore?.getState()?.triggerTransCoding(videoId);
                  } else if (getMediaMetadata?.data?.streamingPlaylists?.length > 0) {
                    resumableQna.duration = getMediaMetadata.data.duration;
                    resumableQna.previewUrl = `${peertubeBase}${getMediaMetadata.data.previewPath}`;
                    resumableQna.videoRawUrl =
                      getMediaMetadata?.data?.streamingPlaylists?.[0].playlistUrl;
                    resumableQna.isTransCoded = true;
                    resumableQna.videoId = getMediaMetadata?.data?.id;

                    useResumableQnaStore.getState().updateResumableQna(resumableQna);
                    useResumableQnaStore
                      .getState()
                      .setTransCodingQueue(`video_id_${videoId}`, resumableQna);
                    useResumableQnaStore.getState().publishVideoToPeerTube({
                      videoId: videoId,
                      resumableQna: resumableQna,
                      shortUUID: resumableQna.shortUUID,
                    });
                  }
                }
              } catch (error) {
                isTransCoding = false;
                resumableQna.status = FeedUploadStatusEnum.ERROR;
                useResumableQnaStore.getState().updateResumableQna(resumableQna);
                console.error('Error in put video:', error);
                let payload = {
                  title: `${resumableQna.translation('page.error')}`,
                  body: `${resumableQna.translation('page.someThingWentWrong')}`,
                };
                displayLocalPush(payload);
                const progresBarConfig = useResumableQnaStore.getState()?.progresBarConfig;
                useResumableQnaStore
                  .getState()
                  .setProgresBarConfig({ ...progresBarConfig, isError: true, inProgress: false });
              }
            }
          } else {
            const resumableQna = useResumableQnaStore?.getState().currentResumableQna;
            useResumableQnaStore
              .getState()
              ?.setTransCodingQueue(`video_id_${videoId}`, resumableQna);
            isTransCoding = false;
            useResumableQnaStore?.getState()?.triggerTransCoding(videoId);
          }
        },
        publishVideoToPeerTube: async (config) => {
          const { videoId, resumableQna, shortUUID } = config;
          const selectedLanguage = useAppPersistenceStore.getState().appLanguage;
          try {
            const publishRes = await StreamClient.put(
              `${getStreamURI()}/api/v1/videos/${videoId}`,
              {
                name: resumableQna.fileName,
                category: null,
                licence: null,
                language: selectedLanguage ? LanguageJson[selectedLanguage] : 'en',
                support: null,
                description: null,
                channelId: resumableQna.channelId,
                privacy: 2,
                tags: null,
                nsfw: false,
                waitTranscoding: true,
                commentsEnabled: true,
                downloadEnabled: true,
                scheduleUpdate: null,
                originallyPublishedAt: null,
              }
            );
            if (publishRes.status === 204) {
              await handleVideoPublishingSuccess(
                resumableQna,
                videoId,
                shortUUID,
                selectedLanguage
              );
            }
          } catch (error) {
            isTransCoding = false;
            resumableQna.status = FeedUploadStatusEnum.ERROR;
            useResumableQnaStore.getState().updateResumableQna(resumableQna);
            console.error('Error in put video:', error);
            let payload = {
              title: `${resumableQna.translation('page.error')}`,
              body: `${resumableQna.translation('page.someThingWentWrong')}`,
            };
            displayLocalPush(payload);
            const progresBarConfig = useResumableQnaStore.getState()?.progresBarConfig;
            useResumableQnaStore
              .getState()
              .setProgresBarConfig({ ...progresBarConfig, isError: true, inProgress: false });
          }
        },
        uploadVideoToMastodon: async (config: {
          payload: {};
          header: {};
          resumableQna: IResumableMedia;
        }) => {
          try {
            const res = await NetworkApi.post(
              paths.postContentInMastodon(),
              config.payload,
              config.header
            );
            if (res) {
              let progresBarConfig = useResumableQnaStore.getState().progresBarConfig;
              config.resumableQna.status = FeedUploadStatusEnum.COMPLETE;
              config.resumableQna.isPublished = true;
              isTransCoding = false;
              useResumableQnaStore.getState().updateResumableQna(config.resumableQna);
              BackgroundService.stop();
              useResumableQnaStore
                .getState()
                .setProgresBarConfig({ ...progresBarConfig, isSuccess: true, inProgress: false });
              useResumableQnaStore
                .getState()
                .removeTransCodingItem(`video_id_${config.resumableQna.videoId}`);
              let payload = {
                title: `${config.resumableQna.translation('page.success')}`,
                body: `${config.resumableQna.translation('page.videoUploadSuccessfully')}`,
              };
              displayLocalPush(payload);
            }
          } catch (error) {
            isTransCoding = false;
            config.resumableQna.status = FeedUploadStatusEnum.ERROR;
            useResumableQnaStore.getState().updateResumableQna(config.resumableQna);
            console.error('Error in put video:', error);
            let payload = {
              title: `${config.resumableQna.translation('page.error')}`,
              body: `${config.resumableQna.translation('page.someThingWentWrong')}`,
            };
            displayLocalPush(payload);
            const progresBarConfig = useResumableQnaStore.getState()?.progresBarConfig;
            useResumableQnaStore
              .getState()
              .setProgresBarConfig({ ...progresBarConfig, isError: true, inProgress: false });
          }
        },
        isVideoUploding: false,
        // setVideoUploding: (flage: boolean) => set({ isVideoUploding: flage }),
        resetResumableQnaStore: () => {
          mmkvUserProfilePersistence.delete(MMKVStoreKeyMap.resumableQnaStore);
          set(initialState);
        },
      }),
      {
        name: MMKVStoreKeyMap.resumableQnaStore,
        storage: createJSONStorage(() => zustandResumableQnaStorage),
      }
    ),
    { enabled: false }
  )
);

const getBackgroundServiceTaskInfo = (resumableQna: IResumableMedia) => {
  const options = {
    taskName: 'NinjaKisaanFileUpload',
    taskTitle: `Uploading ${trimFileName(resumableQna.fileName)}`,
    taskDesc: 'Progress',
    taskIcon: {
      name: 'ic_launcher',
      type: 'mipmap',
    },
    color: '#ff00ff',
    progressBar: {
      max: 100,
      value: 0,
      indeterminate: false,
    },
    //change this for opening the app from notification
    //linkingURI: 'uploadFile',
  };

  return options;
};

const trimFileName = (filename: string) => {
  if (filename) {
    const split = filename.split('.');
    let filenameRaw = split[0];
    const extension = split[1];

    if (filenameRaw.length > 10) {
      filename = filename.substring(0, 10);
      let result = filename + '.' + extension;
      return result;
    }

    return filename;
  }
};

const uploadFileInChunks = async (resumableQna: IResumableMedia, statusUpdate) => {
  const { remoteLocation } = resumableQna;
  let progresBarConfig = useResumableQnaStore.getState().progresBarConfig;

  try {
    const requestConfig: AxiosRequestConfig = getAxiosRequestConfig();
    const axiosHeaders = requestConfig.headers;
    let fileBuffer: any;
    if (Platform.OS === 'web') {
      const arrayBuffer = await resumableQna.mediaFile?.file?.arrayBuffer()!;
      fileBuffer = Buffer.from(arrayBuffer);
    }
    const fileSize =
      Platform.OS !== 'web' ? resumableQna?.mediaFile?.fileSize! : fileBuffer!.length!;
    const { readFile } = useFileSystem();

    let offset = 0;
    const chunkSize = 3 * 1024 * 1024;

    while (offset < fileSize) {
      // const chunk = await RNFS.read(resumableFeed?.mediaFile?.uri!, chunkSize, offset, 'base64');
      let buffer: any;
      if (Platform.OS !== 'web') {
        buffer = await readFile(resumableQna?.mediaFile?.uri!, chunkSize, offset, 'base64');
      } else {
        buffer = await readFile(fileBuffer!, chunkSize, offset, 'base64');
      }
      const readFrom = offset;
      const readTil = Math.min(offset + chunkSize, fileSize);
      axiosHeaders!['content-range'] = `bytes ${readFrom}-${readTil}/${fileSize}`;

      // const buffer = Buffer.from(chunk, 'base64');
      axiosHeaders!['Content-Length'] = buffer.length;

      BackgroundService.updateNotification({
        progressBar: { value: (offset / fileSize) * 100, max: 100, indeterminate: false },
      });
      useResumableQnaStore.getState().setProgresBarConfig({
        ...progresBarConfig,
        progressPercentage: (offset / fileSize) * 100,
        inProgress: true,
      });
      const res = await StreamClient.put(`${remoteLocation}`, buffer, requestConfig);
      if (res.status === 308) {
        offset += chunkSize;
        resumableQna.offsetFrom = offset;
        useResumableQnaStore.getState().updateResumableQna(resumableQna);
        BackgroundService.updateNotification({
          progressBar: { value: (offset / fileSize) * 100, max: 100, indeterminate: false },
        });
        useResumableQnaStore.getState().setProgresBarConfig({
          ...progresBarConfig,
          progressPercentage: (offset / fileSize) * 100,
          inProgress: true,
        });
        continue;
      }

      if (res.status === 200) {
        useResumableQnaStore.getState().setProgresBarConfig({
          isError: false,
          isSuccess: false,
          progressPercentage: 100,
          inProgress: true,
        });
        const { id, shortUUID } = res?.data?.video;
        if (id && shortUUID) {
          resumableQna.videoId = id;
          resumableQna.shortUUID = shortUUID;
          useResumableQnaStore.getState().updateResumableQna(resumableQna);
          useResumableQnaStore?.getState().setCurrentResumableQna(resumableQna);
          isTransCoding = false;
          useResumableQnaStore.getState().triggerTransCoding(id);
        }
        break;
      }
    }
  } catch (err) {
    resumableQna.status = FeedUploadStatusEnum.ERROR;
    statusUpdate(resumableQna);
    console.error('Error in put video:', err);
    let payload = {
      title: `${resumableQna.translation('page.error')}`,
      body: `${resumableQna.translation('page.someThingWentWrong')}`,
    };
    displayLocalPush(payload);
    useResumableQnaStore
      .getState()
      .setProgresBarConfig({ ...progresBarConfig, isError: true, inProgress: false });
  } finally {
  }
};

const getAxiosRequestConfig = () => {
  const peerTubeToken = useProfileStore.getState()?.streamConfig?.access_token;
  const requestConfig: AxiosRequestConfig = {
    onUploadProgress: function (progressEvent) {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total!);
    },
  };

  requestConfig.validateStatus = (status: number) => {
    return status >= 200 && status < 309;
  };

  const videoSegmentedHeader = {
    'content-type': 'application/octet-stream',
    authorization: `Bearer ${peerTubeToken}`,
  };

  requestConfig.headers = videoSegmentedHeader;
  return requestConfig;
};

const handleVideoPublishingSuccess = async (
  resumableQna: IResumableMedia,
  videoId: string,
  shortUUID: string,
  selectedLanguage: string
) => {
  const feedConfig = useProfileStore.getState().feedConfig;
  // const {updateResumableFeed} = useResumableFeedStore()
  // statusUpdate({...resumableFeed,videoId : res.data.video.id,videoPeerTubeUrl : `https://peertube.trafyn.info/w/${res.data.video.shortUUID}`})
  // setVideoConfig({id : res.data.video.id,url : `https://peertube.trafyn.info/w/${res.data.video.shortUUID}`});
  resumableQna.videoId = videoId;
  resumableQna.videoPeerTubeUrl = `${peertubeBase}/w/${shortUUID}`;
  useResumableQnaStore.getState().updateResumableQna(resumableQna);
  const config = {
    payload: {
      status:
        resumableQna?.duration! > 60
          ? `${resumableQna.feedDesc}\n ${resumableQna.videoPeerTubeUrl}\n #system_longvideo #system_${selectedLanguage} #${toolId()}`
          : `${resumableQna.feedDesc}\n ${resumableQna.videoPeerTubeUrl}\n #system_shortvideo #system_${selectedLanguage} #${toolId()}`,
      in_reply_to_id: null,
      media_ids: [],
      sensitive: false,
      spoiler_text: '',
      visibility: 'public',
      poll: null,
      language: 'en',
    },
    header: { authorization: `Bearer ${feedConfig}` },
    resumableQna: resumableQna,
  };
  const CreateModerationbody = {
    input: {
      systemType: 'qna',
      type: 'unapprovedquestion',
      name: useProfileStore.getState()?.userProfile?.user.name,
      title: resumableQna.feedTitle?.slice(0, 250),
      body: resumableQna.feedDesc,
      space: 'scoold',
      tags: [`#system_${selectedLanguage}`],
      creatorid: useProfileStore.getState()?.userProfile?.user.id || '',
      videoUrls: [],
      audioUrls: [],
      medias: [
        {
          id: resumableQna.videoId,
          type: 'video',
          url: resumableQna?.videoRawUrl,
          preview_url: resumableQna?.previewUrl,
          remote_url: null,
          preview_remote_url: null,
          text_url: null,
          meta: {},
          description: null,
          blurhash: null,
        },
      ],
      languagePreference: languageMap[selectedLanguage] ?? 1,
    },
  };
  let payload = {
    userId: useProfileStore.getState()?.userProfile?.user.id || '',
    realmId: useProfileStore.getState()?.userProfile?.realm?.id || '',
  };
  // useResumableFeedStore.getState().uploadVideoToMastodon(config);
  isTransCoding = false;
  const progresBarConfig = useResumableQnaStore.getState().progresBarConfig;
  // useResumableFeedStore.getState().setVideoUploding(true);
  config.resumableQna.status = FeedUploadStatusEnum.COMPLETE;
  config.resumableQna.isPublished = true;
  useResumableQnaStore.getState().updateResumableQna(config.resumableQna);
  BackgroundService.stop();
  useResumableQnaStore.getState().removeTransCodingItem(`video_id_${config.resumableQna.videoId}`);
  const bg_payload = {
    title: `${config.resumableQna.translation('page.success')}`,
    body: `${config.resumableQna.translation('page.videoUploadSuccessfully')}`,
  };
  displayLocalPush(bg_payload);
  const { qna } = await moderationPostQuestionAndFeedAsync(payload, CreateModerationbody);
  if (qna)
    useResumableQnaStore
      .getState()
      .setProgresBarConfig({ ...progresBarConfig, isSuccess: true, inProgress: false });
};
